import '@/assets/scss/reset.scss'
import { createApp } from 'vue'
import App from './Index.vue'
import { plugin as vueMetaPlugin, createMetaManager } from 'vue-meta'

const app = createApp(App);
app.use(createMetaManager());
app.use(vueMetaPlugin);
app.mount('#app');
